<template>

	<div class="cart">
		<button class="btn btn-plain btn-cart-side" @click.prevent="openCart">
			<slot></slot>
			<span class="number">
				<span class="number-value" v-if="cartState.items.length" v-text="totalCartItems"></span>
			</span>
		</button>

		<sidebar ref="sidebar" title="Košarica" class="cart-side">

			<div class="cart-content" ref="cartcontainer" v-show="cartState.items.length">
				<cart-table></cart-table>
			</div>
			<p v-show="!cartState.items.length" v-text="$__('cart.empty_message')"></p>

			<template slot="footer">
				<button class="btn btn-outline-primary" @click.prevent="closeCart" v-text="$__('cart.continue_shopping')"></button>
				<a :href="checkouturl" class="btn btn-primary" v-text="$__('cart.button_checkout')"></a>
			</template>

		</sidebar>
	</div>

</template>
<script>

	import CartTable from "./CartTable";
	import Sidebar from "../Sidebar";

	export default {
		name: 'CartHeader',
		components: {
			CartTable,
			Sidebar,
		},
		props: {
			checkouturl: {
				type: String,
				required: true
			},
			shippings: {
				type: Array,
				default: () => ([])
			},
			payments: {
				type: Array,
				default: () => ([])
			}
		},
		data () {
			return {
				orderModel: {
					is_company: 1,
					extra_delivery: false,
					// payment_id: null,
					// shipping_id: null,
					// name: null,
					// address: null,
					// phone: null,
					// email: null,
					// note: null,
				}
			}
		},
		computed: {
			cartState () {
				return this.$store.state.cart
			},
			totalCartItems () {
				let amount = 0
				this.cartState.items.forEach(element => {
					amount += element.amount
				})
				return amount
			}
		},
		methods: {
			openCart () {
				this.$refs.sidebar.show();

				// View Cart EEC Event
				try {
					const allItems = []
					this.cartState.items.forEach(item => {
						console.log(item)
						const category = item.eec_parent_category ? item.eec_parent_category : item.category
						const subcategory = !item.eec_parent_category ? '' : item.category
						allItems.push({
							'item_id': item.product_id,
							'item_name': item.title,
							'item_variant': undefined,
							'item_brand': 'Lupit Pole',
							'item_category': category ? category : undefined,
							'item_category2': subcategory ? subcategory : undefined,
							'price': item.price,
							'discount': item.eec_discount,
							'affiliation': item.eec_affiliate ? item.eec_affiliate : undefined,
							'quantity': item.amount,
						})
					})
					window.dataLayer = window.dataLayer || [];
					window.dataLayer.push({'event_params': null, 'ecommerce': null});
					window.dataLayer.push({
						'event': 'RO_event_EEC',
						'event_params': {
							'gtm_name': 'EEC_view_cart'
						},
						'ecommerce': {
							'currency': global.current_currency,
							'value': this.cartState.total,
							'items': allItems
						}
					});
				} catch (e) {

				}

			},
			closeCart () {
				this.$refs.sidebar.close();
			},
			formatPrice (price) {
				return numbro(parseFloat(price)).formatCurrency();
			},
		},
		mounted() {
			let vm = this;

			this.$root.$on('cart-open', () => {
				this.$refs.sidebar.show();
			})
		},
		created() {
			this.$store.dispatch('cart/loadCart')
		}
	}

</script>
